import { render, staticRenderFns } from "./BigQueryTable.vue?vue&type=template&id=5bec79b5"
import script from "./BigQueryTable.vue?vue&type=script&lang=ts"
export * from "./BigQueryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports